import {createSelector} from 'reselect';
import {currentStep} from './currentStep';

export const currentStepId = createSelector(
  currentStep,
  currentStep => currentStep.stepId
);
